import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import ManageColorsPopup from '../popups/colors/ManageColorsPopup'
import CreateLocationPopup from '../popups/locations/CreateLocationPopup'
import UpdateLocationPopup from '../popups/locations/UpdateLocationPopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import ListAction from '../../actions/locations/ListTreeAction'
import ReorderAction from '../../actions/locations/ReorderAction'
import DeleteAction from '../../actions/locations/DeleteAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

class LocationsManagePage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isColors: false,
      isCreate: false,
      updateId: null,
      deleteId: null
    }

    // Bind events
    this.onClickReorder = this.onClickReorder.bind(this)
    this.onClickManageColors = this.onClickManageColors.bind(this)
    this.onCloseManageColors = this.onCloseManageColors.bind(this)
    this.onClickCreate = this.onClickCreate.bind(this)
    this.onCloseCreate = this.onCloseCreate.bind(this)
    this.onClickUpdate = this.onClickUpdate.bind(this)
    this.onCloseUpdate = this.onCloseUpdate.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)
  }

  componentDidMount() {
    this.props.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After having reordered a location, update status and reload
    if (
      prevProps.reorderIsFetching
      &&
      !this.props.reorderIsFetching
    ) {
      AppUtils.setStatus(
        this.props.reorderError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.reorderError
          ? AppUtils.errorToText(this.props.reorderError)
          : 'Emplacement réordonné.'
      )
      if (!this.props.reorderError) {
        this.props.fetch()
      }
    }

    // After a location has been deleted, refresh
    if (
      prevProps.deleteIsFetching
      &&
      !this.props.deleteIsFetching
    ) {
      this.setState({
        deleteId: null
      })
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Cet emplacement contient du matériel.'
            })
          : 'Emplacement supprimé.'
      )
      if (!this.props.deleteError) {
        this.props.fetch()
      }
    }
  }

  onClickReorder(id, direction) {
    return () => {
      this.props.reorder(id, { direction })
    }
  }

  onClickManageColors() {
    this.setState({
      isColors: true
    })
  }

  onCloseManageColors(isDirty) {
    this.setState({
      isColors: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickCreate() {
    this.setState({
      isCreate: true
    })
  }

  onCloseCreate(isDirty) {
    this.setState({
      isCreate: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickUpdate(id) {
    return () => {
      this.setState({
        updateId: id
      })
    }
  }

  onCloseUpdate(isDirty) {
    this.setState({
      updateId: null
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDelete(id) {
    return () => {
      this.setState({
        deleteId: id
      })
    }
  }

  onConfirmDelete(proceed) {
    if (proceed) {
      this.props.delete(this.state.deleteId)
    }
    else {
      this.setState({
        deleteId: null
      })
    }
  }

  render() {
    const rows = [];
    const fillRows = (locations, level=0) => {
      _.each(locations, (location) => {
        rows.push(_.extend(
          { level },
          location
        ))
        if (_.isArray(location.children) && location.children.length > 0) {
          fillRows(location.children, level+1)
        }
      })
    }
    if (_.isArray(this.props.list)) {
      fillRows(this.props.list)
    }
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 100%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Emplacements'
              right={
                <React.Fragment>
                  <Grant role={Grant.ROLE.MANAGE}>
                    <Button
                      compact={true}
                      icon='sliders'
                      content='Gérer les couleurs'
                      onClick={this.onClickManageColors}
                    />
                  </Grant>
                  <Grant role={Grant.ROLE.MANAGE}>
                    <Button
                      compact={true}
                      icon='plus'
                      content='Créer'
                      color='green'
                      onClick={this.onClickCreate}
                    />
                  </Grant>
                </React.Fragment>
              }
            />
            <Table
              columns={[
                // Nom
                ColumnsProvider.locationNameHierarchy,
                // Couleur
                ColumnsProvider.genericColor,
                // Etiquetté
                ColumnsProvider.locationIsLabeled,
                // Insp. Tuyaux
                ColumnsProvider.locationPipeInspect,
                // Imprimé
                ColumnsProvider.locationPrintedInventory,
                // Remarque
                ColumnsProvider.locationRemark,
                // Actions
                ColumnsProvider.locationActions(this)
              ]}
              data={rows}
              error={this.props.error}
              isLoading={this.props.isFetching}
              emptyMessage="Il n'existe aucun emplacement pour le moment."
            />
          </Page.Element>
        </Page>
        {
          this.state.isColors
            ? <ManageColorsPopup
                onClose={this.onCloseManageColors}
              />
            : null
        }
        {
          this.state.isCreate
            ? <CreateLocationPopup
                onClose={this.onCloseCreate}
              />
            : null
        }
        {
          !_.isNull(this.state.updateId)
            ? <UpdateLocationPopup
                id={this.state.updateId}
                onClose={this.onCloseUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteId)
            ? <Confirm
                header="Suppression d'un emplacement"
                body="Êtes-vous sûr de vouloir supprimer cet emplacement ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteIsFetching}
                callback={this.onConfirmDelete}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

LocationsManagePage.propTypes = {
  // Properties

  // Redux State
  list: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  reorderId: PropTypes.number,
  reorderData: PropTypes.object,
  reorderIsFetching: PropTypes.bool.isRequired,
  reorderError: PropTypes.object,
  deleteIsFetching: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  reorder: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    list: state.entities.locations.list.tree.data,
    isFetching: state.entities.locations.list.tree.isFetching,
    error: state.entities.locations.list.tree.error,
    reorderId: state.entities.locations.reorder.id,
    reorderData: state.entities.locations.reorder.data,
    reorderIsFetching: state.entities.locations.reorder.isFetching,
    reorderError: state.entities.locations.reorder.error,
    deleteIsFetching: state.entities.locations.delete.isFetching,
    deleteError: state.entities.locations.delete.error
  }),
  (dispatch) => ({
    fetch: () => (dispatch(ListAction({}))),
    reorder: (id, data) => (dispatch(ReorderAction({ id, data }))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.LOCATIONS.LIST)))
  })
)(LocationsManagePage)



// WEBPACK FOOTER //
// ./src/containers/pages/LocationsManagePage.js